import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    Customer,
    Employee,
    Opportunity,
    OpportunityPriority,
    Product,
    SalesCycle,
    SalesCycleCheckListMap
} from '../../models/models';

@Component({
    selector: 'customer-opportunity-form',
    templateUrl: './customer-opportunity-form.component.html',
    standalone: false
})
export class CustomerOpportunityForm implements OnChanges {
    @Input() opportunityID: number = 0;
    @Input() customerID: number = 0;
    //@Input() opportunity: Opportunity = {} as Opportunity;
    @Output() onRefresh = new EventEmitter<any>();

    public opportunity: Opportunity = {} as Opportunity;
    public employeeList: Employee[] = [];
    public productList: Product[] = [];
    public opportunityPriorityList: OpportunityPriority[] = [];
    public salesCycleList: SalesCycle[] = [];
    public salesCycleMap: SalesCycleCheckListMap = {} as SalesCycleCheckListMap;
    public customer: Customer = {} as Customer;

    constructor(private crmService: CRMService,
        private employeeService: EmployeeService, private orderService: OrderService,
        private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.getOpportunityPriorities();
        this.getProducts();
        this.getSalesCycles();
        this.getEmployees();
        //console.log("ngOnInit", this.opportunityID, this.customerID);
    }

    ngOnChanges() {
        if (this.opportunityID > 0) {
            this.getOpportunity();
        }
        else {
            this.opportunity = {
                opportunityID: this.opportunityID,
                customerId: this.customerID,
                productId: 0,
                ownerEmployeeId: 0,
                estimatedRevenue: 0,
                notes: "",
                createDate: new Date(),
                dueDate: new Date(),
                expectedCloseDate: new Date()
            };
        }
        //console.log("ngOnChanges", this.opportunity);
    }

    private getProducts() {
        this.orderService.getProducts().subscribe(result => {
            this.productList = result;
            this.productList = this.productList.sort((left, right): number => {
                if (left.productName < right.productName) return -1;
                if (left.productName > right.productName) return 1;
                return 0;
            });
        });
    }

    private getSalesCycles() {
        this.crmService.getSalesCycles().subscribe(result => {
            this.salesCycleList = result;
            this.salesCycleList = this.salesCycleList.sort((left, right): number => {
                if (left.stage < right.stage) return -1;
                if (left.stage > right.stage) return 1;
                return 0;
            });
            if (this.opportunityID > 0) {
                this.crmService.getCurrentOpportunitySalesCycleMapByOpportunityID(this.opportunityID).subscribe(result => {
                    var checkListMap: SalesCycleCheckListMap[] = result.resultCollection;
                    if (checkListMap.length > 0) {
                        this.salesCycleMap = checkListMap[0];
                    }
                    console.log("getSalesCycles:checklistmap", result);
                });
            }
            else {
                var salesCycle = this.salesCycleList[0];
                this.salesCycleMap.salesCycleId = salesCycle.salesCycleId;
            }
        });
    }

    private getOpportunityPriorities() {
        this.orderService.getOpportunityPriorities().subscribe(result => {
            this.opportunityPriorityList = result.resultCollection;
        });
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employeeList = result;
        });
    }

    private getOpportunity() {
        this.crmService.getOpportunityById(this.opportunityID).subscribe(result => {
            this.opportunity = result;
            this.opportunity.dueDate = new Date(this.opportunity.dueDate);
            this.opportunity.expectedCloseDate = new Date(this.opportunity.expectedCloseDate);
            if (this.opportunity.startDate != null) {
                this.opportunity.startDate = new Date(this.opportunity.startDate);
            }
            console.log("getOpportunity", this.opportunity);
        });
    }

    public getOpportunityNetPerOrder(type: string) {
        var calc: number = 0;
        //if (type == "bid") {
        //    if (this.opportunity.bidAnnualNet != null && this.opportunity.expectedOrderCount != null && this.opportunity.expectedOrderCount > 0) {
        //        calc = this.opportunity.bidAnnualNet / this.opportunity.expectedOrderCount;
        //    }
        //}
        if (type == "expected") {
            if (this.opportunity.expectedAnnualNet != null && this.opportunity.expectedOrderCount != null && this.opportunity.expectedOrderCount > 0) {
                calc = this.opportunity.expectedAnnualNet / this.opportunity.expectedOrderCount;
            }
        }
        else if (type == "actual") {
            if (this.opportunity.actualAnnualNet != null && this.opportunity.actualOrderCount != null && this.opportunity.actualOrderCount > 0) {
                calc = this.opportunity.actualAnnualNet / this.opportunity.actualOrderCount;
            }
        }
        return calc;
    }

    public getOpportunityMargin(type: string) {
        var calc: number = 0;
        //if (type == "bid") {
        //    if (this.opportunity.bidAnnualNet != null && this.opportunity.bidAnnualGross != null && this.opportunity.bidAnnualGross > 0) {
        //        calc = this.opportunity.bidAnnualNet / this.opportunity.bidAnnualGross;
        //    }
        //}
        if (type == "expected") {
            if (this.opportunity.expectedAnnualNet != null && this.opportunity.expectedAnnualGross != null && this.opportunity.expectedAnnualGross > 0) {
                calc = this.opportunity.expectedAnnualNet / this.opportunity.expectedAnnualGross;
            }
        }
        else if (type == "actual") {
            if (this.opportunity.actualAnnualNet != null && this.opportunity.actualAnnualGross != null && this.opportunity.actualAnnualGross > 0) {
                calc = this.opportunity.actualAnnualNet / this.opportunity.actualAnnualGross;
            }
        }
        return calc;
    }

    public dateChanged(dateType: string) {

    }

    public isValid() {
        var valid: boolean = true;
        if (this.opportunity.ownerEmployeeId == null || this.opportunity.ownerEmployeeId <= 0) {
            valid = false;
        }
        if (this.opportunity.notes == null || this.opportunity.notes == "") {
            valid = false;
        }
        if (this.opportunity.productId == null || this.opportunity.productId <= 0) {
            valid = false;
        }
        if (this.opportunity.dueDate == null) {
            valid = false;
        }
        if (this.opportunity.expectedCloseDate == null) {
            valid = false;
        }
        if (this.opportunity.estimatedRevenue == null || this.opportunity.estimatedRevenue < 0) {
            valid = false;
        }
        return valid;
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.opportunity);
        this.crmService.saveOpportunity(this.opportunity).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.opportunityID > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.opportunity = {} as Opportunity;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
